export default __webpack_public_path__ + "static/3-2--c9875d081b5ba126de6ac6206617f4eb.png";